/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LootBoxConfigResponse } from './LootBoxConfigResponse';
import {
    LootBoxConfigResponseFromJSON,
    LootBoxConfigResponseFromJSONTyped,
    LootBoxConfigResponseToJSON,
    LootBoxConfigResponseToJSONTyped,
} from './LootBoxConfigResponse';

/**
 * 
 * @export
 * @interface GetLootBoxConfigResponse
 */
export interface GetLootBoxConfigResponse {
    /**
     * 
     * @type {LootBoxConfigResponse}
     * @memberof GetLootBoxConfigResponse
     */
    lootBoxConfig: LootBoxConfigResponse;
}

/**
 * Check if a given object implements the GetLootBoxConfigResponse interface.
 */
export function instanceOfGetLootBoxConfigResponse(value: object): value is GetLootBoxConfigResponse {
    if (!('lootBoxConfig' in value) || value['lootBoxConfig'] === undefined) return false;
    return true;
}

export function GetLootBoxConfigResponseFromJSON(json: any): GetLootBoxConfigResponse {
    return GetLootBoxConfigResponseFromJSONTyped(json, false);
}

export function GetLootBoxConfigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLootBoxConfigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'lootBoxConfig': LootBoxConfigResponseFromJSON(json['lootBoxConfig']),
    };
}

export function GetLootBoxConfigResponseToJSON(json: any): GetLootBoxConfigResponse {
    return GetLootBoxConfigResponseToJSONTyped(json, false);
}

export function GetLootBoxConfigResponseToJSONTyped(value?: GetLootBoxConfigResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lootBoxConfig': LootBoxConfigResponseToJSON(value['lootBoxConfig']),
    };
}

